import React, { Component } from 'react';
import DocumentTitle from 'react-document-title';
import Success from '../../template/Pay/Success';
import AXIOS from '../../api/axios';
import { COURSE_URL } from "../../constants";
import { parseQuery } from '../../utils/tools';
import clientApi from '../../api/client';

const queryPara = parseQuery(window.location.search.slice(1));

class SuccessPage extends Component {
    constructor(props){
        super(props);
        this.state = {
            result:false,
            stuId:queryPara.stuid,
            courseId: queryPara.courseid
        }
        this.getOrderStatus = ()=>{
            AXIOS.getOrderStatus({
                query:queryPara.orderno
            },(res,err)=>{
                if(err) console.log(err);
                else{
                    if(res.status !== 0){
                        clearInterval(this.interval);
                        if(res.status === 1){
                            this.setState({
                                totalAmount:res.totalAmount,
                                success:1,
                            })
                            clientApi.h5Message({htmlTitle:'支付成功'});
                        }else{
                            this.setState({
                                totalAmount:res.totalAmount,
                                success:0,
                            })
                            clientApi.h5Message({htmlTitle:'支付失败'});
                        }
                        this.setState({result:true,channel:queryPara.channel})
                    }
                }
            })
        }
        if(queryPara.type!=='weixinfail'){
            this.interval = setInterval(()=>{
                this.getOrderStatus();
                setTimeout(() => {
                   clearInterval(this.interval);
                }, 60000*2);
            },3000)
        }else{
            this.state = {
                totalAmount:queryPara.totalamount,
                success:Number(queryPara.success),
                channel:queryPara.channel,
                result:true
            }
        }
        // if(queryPara.orderno){
        
        // else{
        //     if(props.location.state){
        //         this.state = {
        //             num:props.location.state.num,
        //             totalAmount:props.location.state.totalAmount,
        //             success:props.location.state.success,
        //         };
        //     }
        // }
        this.handleBack = this.handleBack.bind(this);
    }
    handleBack(){
        const { history } = this.props;
        history.replace({
            pathname: `${COURSE_URL}/apppay`,
            search:window.location.search
        });
    }
    render(){
        return(
            <DocumentTitle title={`${this.state.result ? '支付完成' : '正在支付'}`}>
                <React.Fragment>
                    <Success {...this.state} handleBack = {this.handleBack} type={queryPara.type} />
                </React.Fragment>
            </DocumentTitle>
        )
    }
}

export default SuccessPage;



// WEBPACK FOOTER //
// ./src/components/payPage/SuccessPage.jsx